import { render, staticRenderFns } from "./IndexMjjy.vue?vue&type=template&id=fdf456d4&scoped=true&"
import script from "./IndexMjjy.vue?vue&type=script&lang=js&"
export * from "./IndexMjjy.vue?vue&type=script&lang=js&"
import style0 from "./IndexMjjy.vue?vue&type=style&index=0&id=fdf456d4&prod&scoped=true&lang=css&"
import style1 from "./IndexMjjy.vue?vue&type=style&index=1&id=fdf456d4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdf456d4",
  null
  
)

export default component.exports